import { useEffect, useState } from 'react';
import { Observable } from '../../Data/Observable/Observable';
import { EventBus } from '../../Data/EventBus/EventBus';
const paramsBus = new EventBus();
const currentRoute = new Observable('');
const prevRoute = new Observable('');
const routes = new Observable([]);
const screens = new Observable([]);
export function useRouteParams(screen, defaultValue) {
    const [params, setParams] = useState(paramsBus.get(screen).value || defaultValue || {});
    useEffect(() => {
        const sub = paramsBus.get(screen).subscribe(setParams);
        return () => sub.unsubscribe();
    }, []);
    return [params];
}
export function getRouteParams(screen, defaultValue) {
    if (!paramsBus.has(screen)) {
        paramsBus.next(screen, defaultValue || {});
    }
    return paramsBus.get(screen);
}
export function submitRouteParams(screen, value) {
    prevRoute.next(currentRoute.value);
    currentRoute.next(screen);
    return paramsBus.next(screen, value);
}
export function getPrevRoute() {
    return prevRoute;
}
export function getRoutes() {
    return routes;
}
export function addRoutes(newScreens) {
    const currentRoutes = [...routes.value];
    const currentScreens = [...screens.value];
    newScreens.forEach(screen => {
        currentRoutes.push(screen.name);
        currentScreens.push(screen);
    });
    screens.next(currentScreens);
    return routes.next(currentRoutes);
}
export function removeRoutes(removedScreens) {
    const alreadyRemovedRoutes = [];
    const currentRoutes = routes.value.filter(screen => {
        if (alreadyRemovedRoutes.includes(screen)) {
            return true;
        }
        if (removedScreens.find(x => x.name === screen)) {
            alreadyRemovedRoutes.push(screen);
            return false;
        }
        return true;
    });
    screens.next(screens.value.filter(screen => currentRoutes.includes(screen.name)));
    return routes.next(currentRoutes);
}
export function getScreenOptions(route) {
    var _a;
    return ((_a = screens.value.find(screen => screen.name === route)) === null || _a === void 0 ? void 0 : _a.options) || {};
}
export function getScreens() {
    return screens;
}
export function getScreen(route) {
    return screens.value.find(screen => screen.name === route);
}
